export default __webpack_public_path__ + "static/media/setion06_kv02.2daf1684.png";